module.exports = __webpack_public_path__ + "assets/ff30195dcc4e793eb152421c48dfbf0a.png";